import { useState, useMemo } from 'react';

const statuses = ['quote', 'scheduled', 'invoiced', 'paid'];
const statusLabels = {
  quote: 'Quote',
  scheduled: 'Scheduled',
  invoiced: 'Invoiced',
  paid: 'Paid'
};

const statusColors = {
  quote: '#3B82F6',      // blue
  scheduled: '#F59E0B',  // amber
  invoiced: '#8B5CF6',   // purple
  paid: '#10B981'        // green
};

export const StatusSlider = ({ status, onChange }) => {
  // Use the prop value directly, deriving the index
  const propIndex = useMemo(() => {
    const idx = statuses.indexOf(status);
    return idx !== -1 ? idx : 0;
  }, [status]);
  
  const [currentIndex, setCurrentIndex] = useState(propIndex);
  
  // Keep internal state in sync with prop when prop changes
  if (propIndex !== currentIndex && statuses[currentIndex] !== status) {
    setCurrentIndex(propIndex);
  }
  
  const handleClick = (index) => {
    setCurrentIndex(index);
    onChange(statuses[index]);
  };

  const currentColor = statusColors[statuses[currentIndex]];

  return (
    <div className="relative" data-testid="status-slider">
      {/* Track */}
      <div className="relative h-12 bg-slate-200 rounded-full flex items-center overflow-hidden">
        {/* Progress fill */}
        <div 
          className="absolute left-0 top-0 bottom-0 transition-all duration-200 ease-out rounded-full"
          style={{
            width: `${((currentIndex + 1) / statuses.length) * 100}%`,
            backgroundColor: currentColor
          }}
        />
        
        {/* Status buttons */}
        <div className="relative z-10 flex w-full">
          {statuses.map((s, index) => {
            const isActive = index <= currentIndex;
            const isCurrent = index === currentIndex;
            
            return (
              <button
                key={s}
                data-testid={`status-${s}`}
                onClick={() => handleClick(index)}
                className={`flex-1 h-12 flex items-center justify-center font-heading font-bold text-xs uppercase tracking-wide transition-colors ${
                  isActive ? 'text-white' : 'text-slate-500'
                } ${isCurrent ? 'scale-105' : ''}`}
              >
                {statusLabels[s]}
              </button>
            );
          })}
        </div>
      </div>
      
      {/* Dots indicator */}
      <div className="flex justify-center gap-2 mt-2">
        {statuses.map((s, index) => (
          <div
            key={s}
            className={`w-2 h-2 rounded-full transition-colors`}
            style={{
              backgroundColor: index === currentIndex ? statusColors[s] : '#CBD5E1'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default StatusSlider;
